import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

type Props = {
  content: CmsApiPage;
};

export function getContentOnlySearchResults({ content }: Props) {
  const { heroSearch } = content;
  return heroSearch && heroSearch.onlyResults;
}
